let Values = {
  PSA        : 'PSA',
  PS         : 'PS',
  PRE        : 'PRE',
  QUARTER    : 'QUARTER',
  SF         : 'SF',
  FRIESIAN   : 'FRIESIAN',
  APPALOOSA  : 'APPALOOSA',
  TROTTER    : 'TROTTER',
  PAINT_HORSE: 'PAINT_HORSE',
  PERCHERON  : 'PERCHERON',
  CUSTOM     : 'CUSTOM'
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value, custom) => {
    switch (value) {

      case Values.CUSTOM:
        return custom;

      default:
        return value;
    }
  }
});
